import React from 'react'
import PropTypes from 'prop-types'
import AddLocation from '@mui/icons-material/AddLocation'

const AddLocationIcon = ({ height, width, ...more }) => {
	
	return (
		<AddLocation
			height={height}
			width={width}
			{...more}
		/>
	)
}

AddLocationIcon.propTypes = {
	height: PropTypes.number.isRequired,
	width: PropTypes.number.isRequired
}

export default AddLocationIcon
